import React from 'react';
import { ControlledRadio, ControlledTextArea } from '@@viewCommonComponents/controlled';
import booleanOptions from '@@viewCommonComponents/forms/options';

const SimulationPricingsDailyBenefitExtraForm = ({ form }) => {
  const contractOnGoing = form.watch('activePolicies.0.contractOnGoing');

  return (
    <>
      <div className="mt-4 mb-4">
        <ControlledRadio
          label={'Disposez-vous d\'un contrat prévoyance (convention collective ou individuelle) ?'}
          id="activePolicies.0.contractOnGoing"
          name="activePolicies.0.contractOnGoing"
          form={form}
          options={booleanOptions}
          booleanValue
        />
      </div>

      {contractOnGoing && (
        <div className="mb-4 w-full">
          <ControlledTextArea
            name="activePolicies.0.comment"
            label={'Quel est son niveau de garantie ?'}
            form={form}
            errors={form.formState.errors}
            rows={2}
            className="max-h-[200px]"
            maxLength={50}
            placeholder="Saisir le niveau de garantie"
          />
        </div>
      )}
    </>
  );
};

export default SimulationPricingsDailyBenefitExtraForm;
